import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem("cr-popia-consent"));

  const decide = (choice) => {
    localStorage.setItem("cr-popia-consent", choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-[85] px-4 pb-4 pointer-events-none"
          data-testid="popia-cookie-banner"
        >
          <div className="glass pointer-events-auto mx-auto flex max-w-4xl flex-col items-center gap-2.5 rounded-3xl p-4 sm:flex-row sm:gap-6 sm:pr-5">
            <span className="hidden rounded-2xl border border-[#241c0d]/15 bg-[#f8b818]/15 p-3 text-[#c87700] sm:block">
              <Cookie size={20} />
            </span>
            <p className="flex-1 text-center text-[11px] leading-snug text-[#241c0d]/85 sm:text-left sm:text-xs">
              We use cookies to run this site smoothly and understand how visitors use it — in line
              with South Africa's POPIA. You choose what you're comfortable with.
            </p>
            <div className="flex gap-2">
              <button onClick={() => decide("declined")} className="btn-outline !px-4 !py-2.5 !text-[11px]" data-testid="cookie-decline-btn">
                Decline
              </button>
              <button onClick={() => decide("accepted")} className="btn-gold !px-4 !py-2.5 !text-[11px]" data-testid="cookie-accept-btn">
                Accept cookies
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
